import { render, staticRenderFns } from "./CarrierList.vue?vue&type=template&id=be60aeb4&scoped=true&"
import script from "./CarrierList.vue?vue&type=script&lang=js&"
export * from "./CarrierList.vue?vue&type=script&lang=js&"
import style0 from "./CarrierList.vue?vue&type=style&index=0&id=be60aeb4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be60aeb4",
  null
  
)

export default component.exports